import React from 'react'
import SocialAccountStats from '../influencer/SocialAccountStats';
import { Link, useNavigate } from 'react-router-dom';
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants';
import Avatar from 'react-avatar';
import YTAccountStat from '../influencer/YTAccountStats';
import { SocialAccountData } from '../../types/influencer/influencerTypes';

const SocialAccountCard: React.FC<{ socialAccount: SocialAccountData }> = ({ socialAccount }) => {

    const platform = socialAccount?.social_account?.platform;
    const navigate = useNavigate();
    return (
        <div className="card card-style overflow-visible p-3 cursor-pointer" onClick={() => navigate(`/i/social-account/${socialAccount?.social_account?.uuid}`)}>
            <div className="row mb-0">
                <div className="col-xl-12">
                    <div>
                        {socialAccount ? (
                            <React.Fragment>
                                <div className="">
                                    {/* Profile Section */}
                                    <div className="d-flex align-items-center position-relative">
                                        {
                                            platform === 'ig' &&
                                            <div
                                                className="symbol symbol-60px symbol-circle position-relative rounded-xl"
                                                style={{ borderColor: "#E24A63", border: '2px solid #E24A63' }}
                                            >
                                                <img src={socialAccount?.social_account?.profile_picture_url} className="rounded-xl" width={50} alt="Profile" />
                                                
                                                <div className="yt-icon-wrapper">
                                                    <i
                                                        className="fa-brands fa-instagram text-danger"
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {
                                            platform === 'yt' && socialAccount?.social_account?.yt &&
                                            <div
                                                className="symbol symbol-60px symbol-circle position-relative rounded-xl"
                                                style={{ borderColor: "#E24A63", border: '2px solid #E24A63' }}
                                            >
                                                {
                                                    socialAccount?.social_account?.profile_picture_url ? (
                                                        <img src={(socialAccount?.social_account?.profile_picture_url ?? '').split("=")[0]} className="rounded-xl" width={50} alt="Profile" />
                                                    ) : (
                                                        <Avatar round size='50' name={socialAccount?.social_account?.yt?.title ?? socialAccount?.social_account?.handle} />
                                                    )
                                                }
                                                <div className='yt-icon-wrapper'>
                                                    <i className="fa-brands fa-youtube text-danger"></i>
                                                </div>
                                            </div>
                                        }

                                        <div className="d-flex flex-wrap flex-column ps-2 flex-fill">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex flex-column gap-2">
                                                    <a
                                                        onClick={(e) => e.stopPropagation()}
                                                        href={`${platform === 'ig' ? 'https://instagram.com/' : 'https://youtube.com/@'}${socialAccount?.social_account?.handle}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="color-theme text-left fw-bold"
                                                    >
                                                        @{socialAccount?.social_account?.handle}
                                                    </a>
                                                    {/* Connection Status */}
                                                {
                                                    platform === 'ig' &&
                                                    <div className="d-flex align-items-center gap-1">
                                                        {
                                                            socialAccount?.status === 'connected' ? (
                                                                <span className="d-inline-block rounded py-0 px-2 bg-success text-white font-11">
                                                                    <small>Connected</small>
                                                                </span>
                                                            ) : socialAccount?.status === 'verified' ? (
                                                                <span className="d-inline-block rounded py-0 px-2 bg-info text-white font-11">
                                                                    <small>Verified</small>
                                                                </span>
                                                            ) : socialAccount.status === 'unverified' ? (
                                                                <span className="d-inline-block rounded py-0 px-2 bg-red-light text-white font-11">
                                                                    <small>Unverified</small>
                                                                </span>
                                                            ) : (
                                                                <span className="d-inline-block rounded py-0 px-2 bg-red-light text-white font-11">
                                                                    <small>Re-Connect</small>
                                                                </span>
                                                            )
                                                        }
                                                    </div>
                                                }
                                                </div>
                                                <Link  to={{pathname:`/i/social-account/${socialAccount.social_account.uuid}`}}>View Details</Link>
                                            </div>
                                        </div>

                                    </div>

                                    {/* Stats Section */}
                                    {
                                        platform === 'ig' ? (
                                            <SocialAccountStats
                                                mediaCount={socialAccount?.social_account?.ig?.media_count ?? 0}
                                                followersCount={socialAccount?.social_account?.ig?.followers_count ?? 0}
                                                followsCount={socialAccount?.social_account?.ig?.follows_count ?? 0}
                                                engagementScore={Number(socialAccount?.social_account?.engagement_score) ?? 0}
                                                engagementRate={Number(socialAccount?.social_account?.engagement_rate) ?? 0}
                                                engagementRateDetails={socialAccount?.social_account?.engagement_rate_details ?? null}
                                            />
                                        ) : platform === 'yt' ? (
                                            <YTAccountStat
                                                videosCount={socialAccount?.social_account?.yt?.video_count ?? 0}
                                                subscribersCount={socialAccount?.social_account?.yt?.subscriber_count ?? 0}
                                                viewsCount={socialAccount?.social_account?.yt?.view_count ?? 0}
                                                engagementScore={Number(socialAccount?.social_account?.engagement_score) ?? 0}
                                                engagementRate={Number(socialAccount?.social_account?.engagement_rate) ?? 0}
                                                engagementRateDetails={socialAccount?.social_account?.engagement_rate_details ?? null}
                                            />
                                        ) : null
                                    }
                                </div>
                                {
                                    platform === 'ig' && socialAccount?.status !== 'connected' &&
                                    <React.Fragment>
                                        <div className="content my-0" onClick={(e) => e.stopPropagation()}>
                                            <u>
                                                <Link to={INIT_IG_AUTH_ROUTE + '?social_account_id=' + socialAccount.social_account.uuid} className="pop pop-link fs-16px">
                                                    {['verified', 'unverified'].includes(socialAccount.status) ? 'Connect' : 'Reconnect'} your Instagram to get premium collabs.
                                                </Link>
                                            </u>
                                        </div>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialAccountCard
